/* DEVELOPER NOTE:

  Find and replace this string, '// DevComment: ' with '' if you want get some
  sweets debug messages. But you have to revert the changes for two reasons:
  1. We want to keep those lines in order to debug again.
  2. No production enviroment should have console o other test committed to
     production.

  Also, help us improve our debugging code. Thanks
*/
!function (global) {
    'use strict';

    var previousListControllerSearch = global.ListControllerSearch;
    var actionsPostLoginUtility = new ActionsPostLoginUtility();
    var resultJobOffersServices = new ResultJobOffersServices();

    function ListControllerSearch(options) {
        var options = options || {};
        var $conf;
        var params;
        var initParams;

        //Modules
        var filters;
        var list;
        var pagination;
        var spinner;
        var breadCrumb;

        var viewErrorHandler;
        // Global Vars
        var apiSearchUrl;
        var apiJobOffferUrl;
        var resources;

        // Filter order
        var $filterOrder;

        // Modals
        var $quickViewModal;

        // Filters
        var sortExpressionText;

        // PushState
        var enablePushState = false;
        var restoreState = false;


        function init() {
            $conf = options.$conf;
            // DevComment: console.group('Module Initialization: Controller');
            // Initialize parameter
            apiSearchUrl = $conf.data('webapi-search');
            apiJobOffferUrl = $conf.data('webapi-joboffer');
            // Init params
            params = $conf.data('request-params');
            resources = $conf.data('resources');
            initParams = $.extend({}, params);

            // Initialize modules
            options.filtersOptions.callback = filterParam;
            options.filtersOptions.$conf = $conf;
            options.filtersOptions.selectedFilters = params;
            filters = new FiltersSearch(options.filtersOptions);

            pagination = new Pagination({
                $container: options.$paginationContainer,
                callback: filterParam,
                hbtpl: $conf.data('hbtpl-pagination'),
                params: $conf.data('pagination'),
                resources: $conf.data('resources'),
            });

            // This module doesn't need callback so far
            list = new ResultList({
                $container: options.$resultsContainer,
                hbtpl: $conf.data('hbtpl-results'),
            });

            // Init spinner
            spinner = new Spinner({
                $selectSpinner: $('.js-spinner'),
                spinnerState: true
            });

            // Init ViewErrorHandler
            viewErrorHandler = new ViewErrorHandler({
                container: $('.js-viewerrorhandler')
            });

            // Init breadCrumb
            breadCrumb = new BreadCrumb({
                $container: options.$breadCrumbContainer,
                hbtpl: $conf.data('hbtpl-breadcrumb')
            });

            // Init PushsState
            enablePushState = !!(window.history && history.pushState);

            // Filter order instance
            $filterOrder = $('.js-filter-order');

            // Filter order binding
            $filterOrder.on('change', function (event) {
                params.sortBy = this.value;
                sortExpressionText = $(this).find("option:selected").text().trim();
                params.pageIndex = 1;
                makeRequest();
            });

            //  // order By instance
            //$filterSortOrderBy = $('.js-filter-SortOrderBy');

            //  // order By binding
            //$filterSortOrderBy.on('change', function (event) {
            //    DevComment: console.log('Si existen $filterSortOrderBy - CompaniesSite listJob joboferrts');
            //    params.sortBy = this.value;
            //    DevComment: console.log(this.value);
            //    sortExpressionText = $(this).find("option:selected").text().trim();
            //    params.pageIndex = 1;
            //    makeRequest();
            //});

            // Bind QuickView
            $quickViewModal = $('#modal-quick-view');
            bindQuickView();

            // Area bind offer detail
            options.$resultsContainer.on('click', '.js-area-bind', function (event) {
                var $area = $(this);
                var $clickTrg = $(event.target);

                //GA4 select_offer
                var offerData = $(this).data("ga4-offerdata");
                //Seteo de fuente de seleccion de la oferta para evento view_offer
                localStorage.setItem("ga4-source", JSON.stringify({ section: offerData.section, list_id: offerData.list_id, list_name: offerData.list_name }));
                selectOfferEvent(offerData);

                if (!$clickTrg.is('a')) {
                    window.location = $area.data('url');
                }
            });

            // Set searchbox info
            if (params.queryPlaceholder != undefined && params.queryPlaceholder != null && params.queryPlaceholder.length > 0) {
                eeGlobal.searchBox.setPlaceHolder(params.queryPlaceholder);
            }

            // Binding and set initial state
            if (enablePushState) {
                window.onpopstate = handlerPopState;
                if (history.state && (restoreState = !eeGlobal.mqDetector.isMobile() ? true : restoreState)) {
                    params = history.state;
                    restoreState = true;
                    makeRequest();
                }
            }

            $quickViewModal.on('shown.bs.modal', function () {
                //Truncate title in 2 lines
                //TODO: Improve event for trucanted : associate case 7063
                $('.js-quick-result-title').trunk8({
                    lines: 2,
                    parseHTML: false
                });
            });

            console.groupEnd();
        }

        function makeRequest() {
            spinner.toggle();

            viewErrorHandler.hideMessages();

            resultJobOffersServices.getResults(params, apiSearchUrl)
                .then(function (data) {
                    return handleResponse(data);
                }).fail(function (param) {
                    return handleErrorResponse();
                });
        }

        function handleResponse(data) {
            var auxFiltersResponse;

            eeGlobal.notification.clean();
            spinner.toggle();


            if (enablePushState) setPushState(data);

            if (data.results.length > 0) {
                filters.update(data.filters, params);
                drawViewResults(data);
                return bindQuickView();
            };

            if (data.results.length <= 0) {
                filters.update(resultJobOffersServices.getAuxFiltersResponse(data), params);
                drawViewResults(data);

                return eeGlobal.notification.warning({
                    title: data.resources.nullSearchTitleText,
                    copy: data.resources.nullSearchMessageText
                });
            }
        }

        function handleErrorResponse() {
            spinner.toggle();
            viewErrorHandler.showWarning(resources.alertResultError);
        }

        function drawViewResults(data) {
            list.render(data.results, data.resources);
            pagination.update(data.paginationInfo, data.resources);
            breadCrumb.update(data.breadcrumbs);

            if (data.isFromNullSearch) {
                eeGlobal.notification.info({
                    title: data.resources.jobOfferNotFoundTitle,
                    copy: data.resources.jobOfferNotFoundDescription,
                    $target: options.$resultsContainer
                });
            }
        }

        function filterParam(filterType, paramValue) {
            if (filterType === 'orderBy') {
                params.sortExpression = paramValue;
                params.pageIndex = 1;
                return makeRequest();
            }

            if (filterType === 'resultsByPage') {
                params.pageSize = paramValue;
                params.pageIndex = 1;
                return makeRequest();
            }

            if (filterType === 'pageNumb') {
                params.pageIndex = paramValue;
                return makeRequest();
            }

            if (filterType === 'paging') {
                if (paramValue == 'all') return makeRequest();
                return;
            }

            params[filterType] = paramValue;
            params.pageIndex = 1;
            list.clean();
            // Make request
            return makeRequest();
        }

        function bindQuickView() {
            var $btnQuickView = $('.js-quickview');

            $btnQuickView.click('click', function (event) {
                var jobOfferId = $(this).data('joboffer');
                var jobOfferurl = $(this).data('jobofferurl');
                showJobOfferQuickView(jobOfferId, jobOfferurl);
            });
        }

        function bindApplyQuickView(userLogged) {
            var $btnApplyQuickView = $('.js-quickview-apply');

            $btnApplyQuickView.click('click', function (event) {
                var jobOfferUrl = $(this).data('joboffer-url');
                var jobOfferId = $(this).data('joboffer-id');

                var postLoginParams = [
                    { Name: 'applyPostLogin', Value: true },
                    { Name: 'jobOfferId', Value: jobOfferId },
                    { Name: 'isQuickView', Value: true }
                ];

                if (userLogged) {
                    if (jobOfferUrl.indexOf('?') > 0) {
                        window.location.href = jobOfferUrl + '&applyPostLogin=true&isQuickView=true';
                    }
                    else {
                        window.location.href = jobOfferUrl + '?applyPostLogin=true&isQuickView=true';
                    }
                } else {
                    var urlBaseLogin = $conf.data('url-login');
                    $quickViewModal.modal('hide');
                    actionsPostLoginUtility.shouldDoLogin({ auxParams: postLoginParams, urlBase: urlBaseLogin });
                }
            });
        }

        function bindShowQuickView() {
            var $btnQuickView = $('.js-view-offer');
            var jobOfferId = $('.js-quickview-apply').data('joboffer-id');

            $btnQuickView.on('click', function (event) {
                //GA4 select_offer
                var offerData = $(this).data("ga4-offerdata");
                //Seteo de fuente de seleccion de la oferta para evento view_offer
                localStorage.setItem("ga4-source", JSON.stringify({ section: offerData.section, list_id: offerData.list_id, list_name: offerData.list_name }));
                selectOfferEvent(offerData);
            });
        }

        function showJobOfferQuickView(jobOfferId, jobOfferurl) {
            var jxqhr;
            var apiUrl = apiJobOffferUrl + '?jobOfferId=' + jobOfferId;

            jxqhr = $.ajax({
                method: 'GET',
                url: apiUrl,
                dataType: 'json',
                contentType: 'application/json; charset=utf-8'
            });
            spinner.toggle();
            jxqhr.done(function (data) {
                spinner.toggle();
                data.jobOfferUrl = jobOfferurl;
                renderJobOfferQuickview(data);
                $quickViewModal.modal('show');

                bindShowQuickView();

                bindApplyQuickView(data.userLogged);
            });

            jxqhr.fail(function () {
                spinner.toggle();
                viewErrorHandler.showWarning(resources.alertResultError);
            });
        }

        function renderJobOfferQuickview(jobOffer) {
            var $container = $('.js-quickview-content');
            var description = jobOffer.description;
            var descRemaining;
            var maxLength = 420;

            if (description.length >= maxLength) {
                // Cut description text and add ellipsis (...)
                description = description.substr(0, maxLength);
                description = description.substr(0, description.lastIndexOf(' '));
                jobOffer.descTruncated = description + '...';

                // Get description remaining
                descRemaining = jobOffer.description.substr(description.length);
                jobOffer.descRemaining = descRemaining.replace(/(<([^>]+)>)/ig, '');
            } else {
                jobOffer.descTruncated = description;
            }

            //GA4 select_offer keywords list
            var keywordlist = (jobOffer.keyWords && jobOffer.keyWords.length) ?
                jobOffer.keyWords.map(function (obj) { return Object.values(obj)[0]; }).join(',') : null;

            //GA4 select_offer
            jobOffer["offerData"] = {
                section: "MICROSITIO",
                id: jobOffer.id,
                title: jobOffer.title,
                company: jobOffer.companyName,
                location: jobOffer.city,
                salary: jobOffer.salaryInfo,
                equivalentPositions: jobOffer.positionStructures,
                tags: keywordlist,
                list_id: "resultado_ofertas_micrositios",
                list_name: "Resultado Ofertas Micrositio"
            };
            //GA4 select_offer serialize offerData
            Handlebars.registerHelper('json', function (context) {
                return JSON.stringify(context);
            });

            // TODO: Get from hidden
            var sourceTpl = $('#hbtpl-jobOffer-quickview').html();
            var hbTpl = Handlebars.compile(sourceTpl);
            var html;

            $container.empty();
            html = hbTpl(jobOffer);
            $container.append(html);
        }

        // PopState

        function setPushState(data) {
            if (restoreState) {
                restoreState = false;
            } else {
                history.pushState(params, '', data.pushUrl);
            }
        }

        function handlerPopState(event) {
            if (event.state != undefined && event.state != "") {
                params = event.state;
            } else {
                params = initParams;
            }
            restoreState = true;
            makeRequest();
        }

        init();
        /*return {}*/

    }

    ListControllerSearch.noConflict = function noConflict() {
        global.ListControllerSearch = previousListControllerSearch;
        return ListControllerSearch;
    };

    global.ListControllerSearch = ListControllerSearch;
}(this);
